import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=60f6972d&scoped=true&lang=pug&"
import script from "./PasswordChange.vue?vue&type=script&lang=js&"
export * from "./PasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./PasswordChange.vue?vue&type=style&index=0&id=60f6972d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6972d",
  null
  
)

component.options.__file = "PasswordChange.vue"
export default component.exports